import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./screens/Home";
import AdminRegistrations from "./screens/AdminRegistrations";
import "./App.css";
import RegisterCourses from "./screens/RegisterCourses";
import MyCourses from "./screens/MyCourses";
import AdminCourses from "./screens/AdminCourses";
import AdminUserTable from "./screens/AdminUserTable";
import AdminFinancialAidTable from "./screens/AdminFinancialAidTable";
import AdminTeachers from "./screens/AdminTeachers";
import TeacherDetails from "./components/TeacherDetails";
import AdminTeacherAccount from "./screens/AdminTeacherAccount";
import ConfirmCheckout from "./screens/ConfirmCheckout";
import AdminGrades from "./screens/AdminGrades";
import AdminSessions from "./screens/AdminSessions";
import AdminSubjects from "./screens/AdminSubjects";
import AdminAccessControl from "./screens/AdminAccessControl";
import AdminRolePermissions from "./screens/AdminRolePermissions";
import NotFound from "./screens/NotFound";
import ClassLectures from "./screens/ClassLectures";
import AdminLectures from "./screens/AdminLectures";
import AdminNotes from "./screens/AdminNotes";
import ClassNotes from "./screens/ClassNotes";
import Explore from "./screens/Explore";
import SelfLearning from "./screens/SelfLearning";
import AdminWorksheets from "./screens/AdminWorksheets";
import ClassWorksheets from "./screens/ClassWorksheets";
import AdminCashLedger from "./screens/AdminCashLedger";
import AdminAttendance from "./screens/AdminAttendance";
import AdminAttendanceCourse from "./screens/AdminAttendanceCourse";
import AdminAttendanceTake from "./screens/AdminAttendanceTake";
import AdminAttendanceSession from "./screens/AdminAttendanceSession";
import AdminBugReports from "./screens/AdminBugReports";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/registrations" element={<AdminRegistrations />} />
          <Route path="/admin/courses" element={<AdminCourses />} />
          <Route path="/admin/attendance" element={<AdminAttendance />} />
          <Route path="/admin/bug-reports" element={<AdminBugReports />} />
          <Route
            path="/admin/attendance/:courseId"
            element={<AdminAttendanceCourse />}
          />
          <Route
            path="/admin/attendance/:courseId/take/:date"
            element={<AdminAttendanceTake />}
          />
          <Route
            path="/admin/attendance/:courseId/sessions/:sessionId"
            element={<AdminAttendanceSession />}
          />
          <Route path="/admin/users" element={<AdminUserTable />} />
          <Route path="/admin/financial-aid" element={<AdminFinancialAidTable />} />
          <Route path="/admin/teachers" element={<AdminTeachers />} />
          <Route path="/admin/teachers/:id" element={<TeacherDetails />} />
          <Route path="/admin/teachers/:id/account" element={<AdminTeacherAccount />} />
          <Route path="/admin/grades" element={<AdminGrades />} />
          <Route path="/admin/admins" element={<AdminAccessControl />} />
          <Route path="/admin/role-permissions" element={<AdminRolePermissions />} />
          <Route path="/admin/sessions" element={<AdminSessions />} />
          <Route path="/admin/subjects" element={<AdminSubjects />} />
          <Route path="/admin/lectures" element={<AdminLectures />} />
          <Route path="/admin/notes" element={<AdminNotes />} />
          <Route path="/admin/worksheets" element={<AdminWorksheets />} />
          <Route path="/admin/cash-ledger" element={<AdminCashLedger />} />
          <Route path="/registercourse" element={<RegisterCourses />} />
          <Route path="/mycourses" element={<MyCourses />} />
          <Route path="/checkout" element={<ConfirmCheckout />} />
          <Route path="/lectures" element={<ClassLectures />} />
          <Route path="/notes" element={<ClassNotes />} />
          <Route path="/worksheets" element={<ClassWorksheets />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/explore/:subjectId/:gradeId" element={<SelfLearning />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
